@if (display) {
  <button class="fuse-mat-button-large w-full bg-gwc-green-500 text-base text-white disabled:bg-gray-300"
    mat-flat-button
    (click)="buttonClicked()"
  [disabled]="!stepIsValid">Next Step: {{ nextStep()?.displayTitle || 'Process Order' }}</button>
}





